// extracted by mini-css-extract-plugin
export var backupIcon = "_t5-1";
export var image = "_t5-0";